import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import Layout from "../../../component/Layout/Layout";
import Card from "../../../component/Layout/theme/card";
import { Input } from "../../../component/form/input";
import LogOut from "../../../component/dashboard/user/logout/logout";
import PageChange from "../../../component/pageChange";
import toast from "react-hot-toast";


function IndexPage() {
    var { t } = useTranslation()
    const { login, token } = useSelector((item) => item.user)
    const [isDataLoad, setIsDataLoad] = useState(false);
    const [currentPlanData, setCurrentPlanData] = useState({})
    const [plansData, setPlansData] = useState([])
    const [checkedPriod, setCheckedPriod] = useState("YEARLY");



    useEffect(() => {
        document.title = "پلن های مالی"
        if (!login) {
            window.location.href = '/auth'
        } else {
            getPlansData()
        }
    }, [])

    async function getPlansData() {
        // توکن ب سرور داده شده و اطلاعات کاربر دریافت
        await fetch(`${process.env.REACT_APP_SERVER}/api/billing/plans`, {
            method: "GET",
            headers: {
                Authorization: "ArNew " + token,
            },
        }).then((res) => {
            res
                .json()
                .then((result) => {
                    if (!result.data) {
                        LogOut();
                        toast.error("شما دسترسی ندارید");
                        window.location.href = '/login';
                    }
                    if (result.status === "success") {
                        setIsDataLoad(true)
                        setPlansData(result.data.plans)
                        setCurrentPlanData(result.data.current)
                    } else {
                        toast.error(result.msg);
                        LogOut();
                        window.location.href = '/login';
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        });
    }


    const getPeriodPay = (period) => {
        switch (period) {
            case "UNLIMITED":
                return "نامحدود"
            case "MONTHLY":
                return "ماهانه"
            case "YEARLY":
                return "ماهانه"
            default:
                return "نامشخص"
        }
    }

    return (
        <>
            <Layout />
            <Card>
                {isDataLoad ? (
                    <div className="p-5 mb-24 bg-white rounded-lg shadow-md">
                        <h1 className="font-extrabold text-2xl text-start text-black mt-5">صورت‌حساب «فضای کاری من»</h1>
                        <h4 className="font-normal text-lg text-start text-gray-500 mt-2">در اینجا می توانید طرح خود را تغییر دهید</h4>

                        <h4 className="font-normal text-lg text-start text-gray-500 mt-8">اگر کد تخفیف دارید اینجا وارد کنید</h4>
                        <div className="flex">
                            <div className="relative mt-4 w-[250px]">
                                <Input
                                    placeholder={"کد را اینجا وارد کنید"}
                                    type="text"
                                    id={"code"}
                                    name={"code"}
                                    autoComplete={"off"}
                                    requiredir={true}
                                    onChange={(e) => {
                                        // setPhone(e.target.value);
                                    }}
                                />
                                <div className="absolute -mt-10 -left-4">
                                    <button
                                        className="px-5 h-9 text-white bg-blue-500 rounded-lg "
                                        type="submit"
                                    // onClick={() => receiveSMS(phoneSms)}
                                    >
                                        ثبت
                                    </button>
                                </div>
                            </div>
                        </div>


                        <hr className="my-10" />
                        <div className="controls-radio">
                            <label className="radio">
                                <input type='radio' onChange={(e) => setCheckedPriod(e.target.value)} name='radioTime' ng-model='radioTimeValue' value='YEARLY' ng-checked={"radioTimeValue === " + checkedPriod} defaultChecked="checked" />
                                سالانه
                            </label>

                            <label className="radio">
                                <input type='radio' onChange={(e) => setCheckedPriod(e.target.value)} name='radioTime' ng-model='radioTimeValue' value='MONTHLY' ng-checked={"radioTimeValue === " + checkedPriod} />
                                ماهانه
                            </label>
                        </div>
                        <hr className="my-10" />


                        <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-2 gap-3">

                            {plansData.filter((elem) => elem.period == checkedPriod || elem.currency == "FREE").map((item, index) => {
                                return (
                                    <div key={index} className="flex flex-col">
                                        <div className="flex flex-col p-8 mb-5 bg-[#f2f4f6] rounded-lg border border-[#e6e8ea] text-center">
                                            <span className="font-normal text-xl text-black w-full">{item.name}</span>
                                            <span className="font-normal text-xl text-gray-700 w-full mt-5">{item.description}</span>
                                            <span className="font-normal text-xl text-black w-full mt-3">{getPeriodPay(item.period)}</span>

                                            <span className="font-extrabold text-3xl text-black w-full mt-10">{item.currency == "FREE" ? item.price : item.price / 1000}</span>
                                            <span className="font-extrabold text-3xl text-black w-ful mt-1">هزار تومان</span>
                                            <span className="font-normal text-xl text-black w-full mt-3">در ماه</span>


                                            <span className="font-normal text-xl text-black w-full mt-5">{item.view_limited == 0 ? "نامحدود" : `${item.view_limited} بازدید`}</span>

                                            {
                                                currentPlanData && currentPlanData._id == item._id
                                                    ?
                                                    (
                                                        <button className="font-medium text-lg text-gray-700 bg-gray-300 hover:bg-gray-300 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg w-full px-5 py-2.5 text-center mt-10">فعال</button>
                                                    ) : (
                                                        item.currency != "FREE" ?
                                                            (
                                                                <Link to={`/billing/payment/${item._id}`}>
                                                                    <button className="w-full font-medium text-lg text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg px-5 py-2.5 text-center mt-10">انتخاب</button>
                                                                </Link>
                                                            ) : (
                                                                <button className="font-medium text-lg text-gray-700 bg-gray-300 hover:bg-gray-300 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg w-full px-5 py-2.5 text-center mt-10">غیرفعال</button>
                                                            )

                                                    )
                                            }

                                        </div>
                                        {item.feature.map((item, index) => {
                                            return (
                                                <div key={index} className="flex p-2">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="mt-1" fill="#00ac8b" height="1.2em" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg>
                                                    <div className="px-2 font-normal text-xl text-black">{item}</div>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )
                            })}


                        </div>
                    </div>
                ) : (
                    <PageChange />
                )}
            </Card>
        </>
    )
}

export default IndexPage